import { Component, h, Prop, State } from '@stencil/core';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import { has } from 'lodash';
import '../header-component/header-component';
import '../loader-component/loader-component'
// import $ from "jquery";

/** 
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/carousel-component.PNG)

#### Content Type
nypwebc_ct_picture
  
*/

@Component({
  tag: 'carousel-component-v2',
  styleUrl: 'carousel-component-v2.css',
  // shadow: true,
  scoped: true
})
export class CarouselComponentV2 {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

    /**
  *Optional - To show/hide header. default is true
  */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;

   
     /**
 *Optional - header background color
 */
 @Prop() headerbgcolor: string ="white"
 
 /**
 *Optional -header text color
 */
 @Prop() headertextcolor: string = "black"
 /**
 *Optional -header border bottom css
 */
 @Prop() headerborderbottom: string = "1px solid #CE2127"

     /**
  *Optional -image border radius 
  */
  @Prop() imageradius: string = '10%'

  /**
*Optional - is it SP Online site
*/
@Prop() online:boolean=false;
 /**
  *Required - site url if its sp online site
  */
  @Prop() siteurl: string = "";

    /**
 *Optional - To show see All link
 */
 @Prop() seeall: boolean = false;
 /**
*Optional - see All link
*/
 @Prop() seeallurl: string;

     /**
*Optional - see All link Title
*/
@Prop() seealltitle: string ="See All"


 

  @State() items: [];
  @State() isLoading: boolean = true;
  @State() modalShow: boolean = false;

  @State() modelBody
  @State() modelTitle
  @State() modelImageUrl
  // @State() modalvideourl:string = "";

  handleClose =() => {

    // this.modalvideourl = $('.raw-html-style video source').attr('src')
    // $('.raw-html-style video').attr('src','')
    // $('.raw-html-style video source').attr('src','')
    this.modalShow = false
    
  }

  handleShow = (event, body, title, image) => {

    console.log(body, title, image, event)

    let bodystring: string = ""
    let domNode: any;
    let bodyexist: boolean = false

    if (body != null) {
      bodystring = body;
      bodyexist = true;
      let parser = new DOMParser();
      domNode = parser.parseFromString(bodystring, "text/html");
      const img = domNode.querySelectorAll("img");
      const tables = domNode.querySelectorAll("table");

      for (let i = 0; i < img.length; i++) {
        img[i].classList.add("sc-carousel-component", "img-fluid", "rounded");
      }
    }



    this.modalShow = true
    // this.modelBody = domNode.body.innerHTML
    this.modelTitle = title
    this.modelImageUrl = image
//     if (this.modalvideourl) {
//     $('.raw-html-style video source').attr ('src',this.modalvideourl)
//     $('.raw-html-style video').attr ('src',this.modalvideourl)
// }

  }


  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    // let siteUrl:string="";
    
    // if (this.online) {
    //   siteUrl=this.siteurl+this.webpath 
    // }
    // else
    // {
    //   siteUrl=(window as any)._spPageContextInfo.siteAbsoluteUrl+this.webpath ;
    // }


    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }
    const filter = "nypwebc_Active eq 1";


    return fetch(siteUrl +  "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_Active,nypwebc_JobTitle,FileLeafRef,nypwebc_ItemOrder,nypwebc_ReadMore,nypwebc_Body&$filter=" + filter + "&$orderby=nypwebc_ItemOrder", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }


  getCarouselIndicators = () => {

    const carouselIndicators = [];
    let hashComponentId = "#" + this.componentid;
    this.items.forEach((item: any, index) => {

      if (index === 0) {
        carouselIndicators.push(

          <button type="button" data-bs-target={hashComponentId} data-bs-slide-to={index} class="active" aria-current="true" aria-label={item.Title}></button>
        )
      }
      else {
        carouselIndicators.push(
          <button type="button" data-bs-target={hashComponentId} data-bs-slide-to={index} aria-label={item.Title}></button>)
      }
    });
    return carouselIndicators
  }

  getCarouselItems = () => {

    let imagestyle = {
      'border-radius' :   this.imageradius
    }
    
    const carouselItems = [];
    let modalComponentId = "#modal" + this.componentid

    this.items.forEach((item: any, index) => {


      // let readMoreElement = ''
      // let readMoreUrl = ""

      // if (item.nypwebc_ReadMore) {
      //   readMoreUrl = item.nypwebc_ReadMore
      // }
      // else{
      //   readMoreUrl = <a href="#"   id={item.ID} onClick={(e) => this.handleShow(item.JobDescription,item.Title,srcUrl)}></a> 
      // }



      let srcUrl = this.webpath + "/" + this.listname + "/" + item.FileLeafRef

      if (item.nypwebc_ReadMore) {
        if (index === 0) {
          carouselItems.push(<div class="carousel-item active">
            <a href={item.nypwebc_ReadMore} target= "_blank"  data-interception="off" id={item.ID} rel="noopener noreferrer" ><div class="card " >
              <img src={srcUrl} class="img-fluid mx-auto d-block"  style={imagestyle}/>
              <div class="card-body">
                {/* <div class="card-title">{item.Title}</div> */}
                <div class="card-text">
                  {item.Title}
                </div>
              </div>
            </div>
            </a>
          </div>)
        }
        else {
          carouselItems.push(<div class="carousel-item">
            <a href={item.nypwebc_ReadMore} target= "_blank"  data-interception="off" id={item.ID} rel="noopener noreferrer" ><div class="card" >
              <img src={srcUrl} class="img-fluid mx-auto d-block" style={imagestyle} />
              <div class=" card-body">
                {/* <div class="card-title">{item.Title}</div> */}
                <div class="card-text">
                  {item.Title}
                </div>
              </div>
            </div>
            </a>
          </div>)
        }

      }

      else {
        if (index === 0) {
          carouselItems.push(<div class="carousel-item active">
            <a href='#' onClick={(event) => this.handleShow(event, item.nypwebc_Body, item.Title, srcUrl)} data-bs-toggle="modal" data-bs-target={modalComponentId} id={item.ID} rel="noopener noreferrer" >
              <div class="card " >
                <img src={srcUrl} class="img-fluid mx-auto d-block" style={imagestyle} />
                <div class=" card-body ">
                  {/* <div class="card-title">{item.Title}</div> */}
                  {/* <a href='#' onClick={(event) => this.handleShow(event, item.nypwebc_Body, item.Title, srcUrl)} data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-backdrop="false" data-backdrop="false" id={item.ID} rel="noopener noreferrer" > Click Here</a> */}
                  <div class="card-text">
                    {item.Title}
                  </div>
                </div>
              </div>
            </a>
          </div>)
        }
        else {
          carouselItems.push(<div class="carousel-item">
            <a href='#' onClick={(event) => this.handleShow(event, item.nypwebc_Body, item.Title, srcUrl)} data-bs-toggle="modal" data-bs-target={modalComponentId} id={item.ID} rel="noopener noreferrer" ><div class="card" >
              <img src={srcUrl} class="img-fluid mx-auto d-block" style={imagestyle} />
              <div class=" card-body ">
                {/* <div class="card-title">{item.Title}</div> */}
                <div class="card-text">
                  {item.Title}
                </div>
              </div>
            </div>
            </a>
          </div>)
        }


      }
    });
    return carouselItems
  }


  render() {
    let hashComponentId = "#" + this.componentid;
    let modalComponentId = "modal" + this.componentid
    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }

    let modalVisibilty = "modal"
    if (this.modalShow) {
      modalVisibilty = "modal show"
    }





    return (
      this.isLoading ? <loader-component /> :

        this.header && this.items.length > 0  ?

          <div>

            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} seeall={this.seeall} seealltitle= {this.seealltitle} seeallurl={this.seeallurl} />

            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
                <div id={this.componentid} class="carousel carousel-dark carousel-fade"  data-bs-ride="carousel"   style={{ margin: "30px" }} >
                  {/* <div class="carousel-indicators" style={{ bottom: "-40px" }}>
                    {this.getCarouselIndicators()}
                  </div> */}
                  <div class="carousel-inner" >
                    {this.getCarouselItems()}
                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target={hashComponentId} data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target={hashComponentId} data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                  <div class="carousel-indicators" >
                    {this.getCarouselIndicators()}
                  </div>
                </div>
              </div>

              <div class="container">
              <div class={modalVisibilty} id={modalComponentId} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">{this.modelTitle}</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" onClick={this.handleClose} aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12" >
                          <img class="rounded mx-auto d-block img-fluid border-0" src={this.modelImageUrl} />
                        </div>
                        </div>
                        {/* <div class="row">
                        <div class="col-md-12">
                          <p > <div class="raw-html-style" innerHTML={this.modelBody} /> </p>
                        </div>
                      </div> */}
                      </div>
                      <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-bs-dismiss="modal" onClick={this.handleClose}> Close</button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              </div>

            </div>



            :
            <div class="row gx-0" style={parentstyle} >
              <div style={style}>
                <div id={this.componentid} class="carousel carousel-dark slide"  data-bs-ride="carousel" data-bs-interval= "4000" style={{ margin: "30px" }} >
                  {/* <div class="carousel-indicators" style={{ bottom: "-40px" }}>
                  {this.getCarouselIndicators()}
                </div> */}
                  <div class="carousel-inner" >
                    {this.getCarouselItems()}

                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target={hashComponentId} data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target={hashComponentId} data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                  <div class="carousel-indicators" >
                    {this.getCarouselIndicators()}
                  </div>
                </div>

              </div>

                <div class="container">
              <div class={modalVisibilty} id={modalComponentId} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">{this.modelTitle}</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" onClick={this.handleClose} aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12 " >
                          <img class="rounded mx-auto d-block img-fluid border-0" src={this.modelImageUrl} />
                        </div>
                        </div>
                        {/* <div class="row">
                        <div class="col-md-12">
                          <p > <div class="raw-html-style" innerHTML={this.modelBody} /> </p>
                        </div>
                      </div> */}
                    </div>
                    
                    <div class="modal-footer">
                      <button class="btn btn-secondary" type="button" data-bs-dismiss="modal" onClick={this.handleClose}> Close</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            )
  }
}
